import { render, staticRenderFns } from "./FacturaFormComponent.vue?vue&type=template&id=1812f7e6&"
import script from "./FacturaFormComponent.vue?vue&type=script&lang=js&"
export * from "./FacturaFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports